import { httpGet } from '@/utils/service'

export async function findByCountryCode (country) {
  try {
    const response = await httpGet('GET_SETTINGS', {
      params: {
        country: country || 'undefined'
      }
    })
    return response.data
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data
    }

    throw error
  }
}
